<template>
  <div v-if="visible" class="ai-workflow-overlay">
    <!-- Loading State -->
    <div v-if="state === 'loading'" class="overlay-card loading-state">
      <div class="loading-animation">
        <AIGeneratingAnimation />
      </div>
      <p class="loading-text">AI Agent is working on your Workflow ...</p>
    </div>

    <!-- Error State -->
    <div v-else-if="state === 'error'" class="overlay-card error-state">
      <button class="close-btn" @click="$emit('close')">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <img src="@/assets/MyWorkBench/Workflow/something_wrong.svg" alt="Error" class="error-image" />
      <p class="error-text">Something went wrong ...</p>
    </div>
  </div>
</template>

<script>
import AIGeneratingAnimation from './AIGeneratingAnimation.vue';

export default {
  name: 'AIWorkflowOverlay',
  components: {
    AIGeneratingAnimation
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: 'loading', // 'loading', 'error'
      validator: (value) => ['loading', 'error'].includes(value)
    }
  }
};
</script>

<style scoped>
.ai-workflow-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.overlay-card {
  position: relative;
  background: white;
  padding: 48px 64px;
  border-radius: 16px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  pointer-events: auto;
}

/* Loading State */
.loading-animation {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-text {
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #333;
  margin: 0;
}

/* Error State */
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: #F3F4F6;
}

.close-btn svg {
  width: 24px;
  height: 24px;
}

.error-image {
  width: 400px;
  height: auto;
}

.error-text {
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #333;
  margin: 0;
}
</style>
